export default "__VITE_ASSET__DLS47Igq__"